import { render, staticRenderFns } from "./v-understand.vue?vue&type=template&id=4ca8669a&"
import script from "./v-understand.vue?vue&type=script&lang=js&"
export * from "./v-understand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports